import styled from "@emotion/styled"

const ArticleAuthorRole = styled.span`
  display: block;
  font-weight: 500;
  color: #c6c6db;
  font-size: 12px;
  line-height: 120%;
`

export default ArticleAuthorRole
